import {FlyerDto, FlyerFrameSettingDto, FlyerPageDto, FlyerPageSpotDto} from '../../../../../dtos'
import {FlyerPage, IFlyerPageRef} from './flyerPage/FlyerPage'

import {FlyerPagesArrows} from '../../../../com/flyerPages/arrows/FlyerPagesArrows'

import {SpotsSizeSelector} from './spotsSizeSelector/SpotsSizeSelector'


import './FlyerPages.scss'
import React, {forwardRef, ReactElement, Ref, useCallback, useImperativeHandle, useRef, useState} from 'react'
import {useEffect} from 'react'
import {Box} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {
    addEventDataTypeListener,
    dispatchEventDataType,
    EVENT_TYPE_CHANGE_ICON_POSITION,
    EVENT_TYPE_GET_ALL_SELECTED_SPOTS,
    removeEventTypeListener
} from "../../../../../globals/EventDispatcher";
import {ITopBarRef, TopBar} from "../../../../com/flyerPages/topBar/TopBar";
import {SpotsTopBarControls} from "../topBarControls/SpotsTopBarControls";
import {FlyerPageControls} from "./controls/FlyerPageControls";
import {FramesScreenRightPanel} from "./FramesScreenRightPanel";
import {findOwnPropertiesForSelectedFrames} from "../../../../../globals/globalProjectFunctions";
import * as Globals from "../../../../../globals";
import {QualityCheck} from "../../../../../com/qualityCheck/qualityCheck";
import {useTypedSelector} from "../../../../../hooks/useTypeSelector";

const useStyle = makeStyles(() => ({
    flyerPagesContainerSpots: {
        position: `relative`,
        display: `flex`,
        flexFlow: `row`,
        width: `100%`,
        flex: `1 1 auto`,
        height: `0`,
        overflow: `hidden`,
        '& > .canvas_container': {
            position: `absolute !important`,
            left: `10px`,
            top: `44px`,
            zIndex: 5
        }
    },
    flyerFramesPagesContent: {
        flex: `1 1 auto`,
        display: `flex`,
        flexFlow: `column`
    },
    rightPanelForFrame: () => ({
        width: `360px`,
        height: `100%`,
        position: `relative`,
    }),
}))

export interface IFlyerPagesRef {
    showSotsSizeSelectorGrid: (value: boolean) => void
}

export interface ICoordinatesAndSizesForSelectedFrameDto {
    x: number | null;
    y: number | null;
    width: number | null;
    height: number | null;
}

interface IFlyerPages {
    pageIndex: number,
    data?: FlyerDto,
    // onLeftArrowClick: () => void,
    // onNextArrowClick: () => void,
    isDisabledZoom: boolean;
    total: number;
    setZoomStatus: any;
    // index zero based
    onPageIndexChanges: (index: number) => void;
    flyerPagesRef: React.RefObject<IFlyerPagesRef>,

    leftChildren?: ReactElement
    rightChildren?: ReactElement
    isDragStart?: boolean;
}

export const FlyerPages = forwardRef((props: IFlyerPages, ref: Ref<IFlyerPagesRef>) => {

    // create peer between interface and actual implementation
    useImperativeHandle(ref, () => ({showSotsSizeSelectorGrid}));
    const topBarReference = useRef<ITopBarRef>(null)
    // const containerRef = useRef(null);
    const {toggleActionsForFlyers} = useTypedSelector((state) => state);
    const flyerPageRef = useRef<IFlyerPageRef>(null)
    const contentPagesRef = useRef<HTMLDivElement>(null)
    const scrollWrapper = useRef<HTMLDivElement>(null)

    const [pageDto, setPageDto] = useState<FlyerPageDto | undefined>();
    const [showSpotsSizeSelector, setShowSpotsSizeSelector] = useState(false);
    const [selectedFrames, setSelectedFrames] = useState<FlyerPageSpotDto[]>([]);
    const [defaultFramesState, setDefaultFrameState] = useState<FlyerFrameSettingDto>({});
    const [currentFramesState, setCurrentFrameState] = useState<FlyerFrameSettingDto>({});
    const [coordinatesAndSizesForSelectedFrame, setCoordinatesAndSizesForSelectedFrame] = useState<ICoordinatesAndSizesForSelectedFrameDto | null>({
        x: null,
        y: null,
        width: null,
        height: null,
    })
    const stylesProperties = {
        isSelectedFrames: selectedFrames.length > 0
    }
    const classes = useStyle(stylesProperties);
    const showSotsSizeSelectorGrid = (value: boolean) => {
        setShowSpotsSizeSelector(value)
    }


    useEffect(() => {

        addEventDataTypeListener(EVENT_TYPE_GET_ALL_SELECTED_SPOTS, (data: any) => {
            if (data.data.selectedFramesData.length === 1 && props.data?.flyerPages![props.pageIndex]) {
                let scaleX = props.data?.flyerPages![props.pageIndex].flpWidthPx! / Globals.FLYER_CANVAS_WIDTH;
                let scaleY = props.data?.flyerPages![props.pageIndex].flpHeightPx! / Globals.FLYER_CANVAS_HEIGHT;

                const x1 = Math.floor((data.data.selectedFramesData[0].x + data.data.selectedFramesData[0]._bounds.width) * scaleX);
                const y1 = Math.floor((data.data.selectedFramesData[0].y + data.data.selectedFramesData[0]._bounds.height) * scaleY);
                const x = Math.round(data.data.selectedFramesData[0].x * scaleX);
                const y = Math.round(data.data.selectedFramesData[0].y * scaleY);
                const width = x1 - x;
                const height = y1 - y;
                setCoordinatesAndSizesForSelectedFrame({x, y, width, height})
            } else {
                setCoordinatesAndSizesForSelectedFrame(null);
            }
            const selectedFrameData: FlyerFrameSettingDto = findOwnPropertiesForSelectedFrames(data.data.selectedFrames);
            setDefaultFrameState(selectedFrameData);
            setCurrentState(selectedFrameData);
            setSelectedFrames(data.data.selectedFrames);
        })
        return () => {
            removeEventTypeListener(EVENT_TYPE_GET_ALL_SELECTED_SPOTS)
        }

    }, [props.pageIndex]);

    useEffect(() => {
        flyerPageRef.current?.reInit();
        flyerPageRef.current?.showLoader(true);
        const pageDto = props.data?.flyerPages![props.pageIndex]!;
        setSelectedFrames([]);
        // const pageDto = props.data?.flyerPages![selectedPageState.pageNo === 0 ? 0 : selectedPageState.pageNo - 1]!
        setPageDto(pageDto)

    }, [props.data?.flyerPages, props.pageIndex]);

    let scrollCount: any = null;
    let scrollRef: any = null;
    const scroll = useCallback(
        y => {
            // setTimeout(() => {
                console.log(`scrollPageOnScreen`);
                if (y > 0) {
                    topBarReference.current!.showNext();
                    // props.onNextArrowClick();
                } else {
                    topBarReference.current!.showBack();
                    // props.onLeftArrowClick();
                }
            // }, 600)
        },
        [scrollWrapper]
    );

    useEffect(() => {
        const sliderElement = scrollWrapper.current;
        // Passing the same reference
        // const targetSlider = sliderRef.current as unknown as HTMLDivElement
        if (sliderElement) {
            sliderElement.addEventListener('wheel', onScrollPages)
        }
        if(toggleActionsForFlyers.isZoomIn && sliderElement){
            sliderElement.removeEventListener('wheel', onScrollPages);
        }

        return () => {
            // Passing the same reference
            const sliderElement = scrollWrapper.current;
            if (sliderElement) {
                sliderElement.removeEventListener('wheel', onScrollPages)

            }
        }
        // dispatch(setSelectedPageForTabs({
        //     pageNo: selectedPageState.pageNo - 1
        // }));
    }, [scroll, toggleActionsForFlyers.isZoomIn]);

    useEffect(() => {
        if (currentFramesState.fpsFrameType
            && Number(currentFramesState.fpsIconXPct) >= 5
            && Number(currentFramesState.fpsIconXPct) <= 95
            && Number(currentFramesState.fpsIconYPct) >= 5
            && Number(currentFramesState.fpsIconYPct) <= 95
        ) {
            dispatchEventDataType(EVENT_TYPE_CHANGE_ICON_POSITION, {
                iconXPercentageNumber: currentFramesState.fpsIconXPct,
                iconYPercentageNumber: currentFramesState.fpsIconYPct,
                type: currentFramesState.fpsFrameType
            });
        }

    }, [currentFramesState.fpsIconXPct, currentFramesState.fpsIconYPct, currentFramesState.fpsFrameType])

    const onScrollPages = (e: any) => {
        clearTimeout(scrollRef);
        scrollRef = setTimeout(() => {
                scrollCount = 0;
            },
            200);
        if (scrollCount) {
            return;
        }
        scrollCount = 1;
        scroll(e.deltaY);
    }

    const setCurrentState = (currentFramesState: FlyerFrameSettingDto) => {
        setCurrentFrameState(currentFramesState);
    }


    const onClickNext = () => {
        topBarReference.current!.showNext();
    }

    const onClickPrev = () => {
        topBarReference.current!.showBack();
    }

    return (
        <div className={classes.flyerPagesContainerSpots} ref={contentPagesRef}>
            <Box className={classes.flyerFramesPagesContent}>
                <TopBar
                    screen={"frames"}
                    ref={topBarReference}
                    total={props.data?.flyerPages?.length!}
                    onPageIndexChanges={props.onPageIndexChanges}
                    pageIndex={props.pageIndex}
                    leftChildren={(
                        <SpotsTopBarControls
                            showNewSpotControls={(value: boolean) => props.flyerPagesRef?.current?.showSotsSizeSelectorGrid(value)}
                        />
                    )}
                    rightChildren={(
                        <Box sx={{
                            display: "flex",
                            flexFlow: "row",
                            columnGap: "12px"
                        }}>
                            <QualityCheck/>
                            <FlyerPageControls
                                // selectAllPageSpots={(value: boolean) => flyerPageRef.current!.selectAllPageSpots(value)}
                                // deleteAllPageSpots={() => flyerPageRef.current!.deleteAllPageSpots()}
                                pageIndex={props.pageIndex}
                                setZoomStatus={props.setZoomStatus}
                                selectedFrames={selectedFrames}
                                framesOnPage={pageDto && pageDto.flyerPageSpots ? pageDto.flyerPageSpots : []}
                            />
                        </Box>

                    )}
                    selectedFramesData={selectedFrames}
                    defaultFramesState={defaultFramesState}
                    currentFramesState={currentFramesState}
                />
                <Box
                    id={'flyerCanvasContainer'}
                    ref={scrollWrapper}
                    sx={{
                        flex: `1 1 auto`,
                        display: `flex`,
                        justifyContent: `center`,
                        alignItems: `center`,
                        position: `relative`,
                        padding: "4px",
                        overflow: "auto"
                        // overflow: `auto`
                    }}
                >
                    {
                        props.total > 1 && <FlyerPagesArrows
                            onLeftArrowClick={onClickPrev}
                            onNextArrowClick={onClickNext}
                            pageIndex={props.pageIndex}
                            totalPages={props.total}
                        />
                    }
                    <FlyerPage ref={flyerPageRef} data={pageDto} isDisabledZoom={props.isDisabledZoom}
                               selectedFrames={selectedFrames} setSelectedFrames={setSelectedFrames}/>
                </Box>
            </Box>
            <Box
                className={classes.rightPanelForFrame}
            >
                <FramesScreenRightPanel
                    selectedFramesData={selectedFrames}
                    pageDto={pageDto ? pageDto : {}}
                    currentFramesState={currentFramesState}
                    setCurrentState={setCurrentState}
                    defaultFramesState={defaultFramesState}
                    coordinatesAndSizesForSelectedFrame={coordinatesAndSizesForSelectedFrame}
                />
            </Box>


            {showSpotsSizeSelector &&
                <SpotsSizeSelector
                    onGridSizeSelected={(rows: number, columns: number) => {
                        flyerPageRef.current!.setNextGridSize(rows, columns)
                    }}
                />
            }

        </div>
    )
})